








import { Vue, Component, Prop } from "vue-property-decorator"
import Popup from "@/components/Postscript/Popup.vue"
import Loading from "@/components/Loading.vue"
import Mark from "mark.js"
import api from "../../honcierge-api"
import { mapActions } from "vuex"
import {
  ArticlePostscript,
  Postscript as PostscriptType,
  ResponseArticle,
} from "types/index"
import { AxiosError, AxiosResponse } from "axios"

@Component({
  components: {
    Loading,
  },
  methods: {
    ...mapActions("article", ["updateArticle"]),
  },
})
export default class Postscript extends Vue {
  @Prop()
  private postscripts!: PostscriptType["data"][]

  @Prop()
  private popupHTML!: { [key: number]: string }

  private isLoading = false

  private updateArticle!: (o: {
    editorData: ArticlePostscript["data"]["editorData"]
  }) => Promise<AxiosResponse<ResponseArticle["patch"]>>

  public created(): void {
    this.renderPostscript()
  }

  private renderPostscript() {
    Vue.component("async-postscript", (resolve) => {
      resolve({
        template:
          '<div class="main-area">' +
          this.$store.state.article.editorData +
          "</div>",
        mounted: () => {
          this.postscript()
        },
      })
    })
  }

  // mark.jsで校正チェック
  private postscript() {
    this.postscripts.forEach((postscript) => {
      let clsName
      if (postscript.alertLevel === "forbidden") {
        clsName = "highlight forbidden pid-" + postscript.id
      } else if (postscript.alertLevel === "caution") {
        clsName = "highlight caution pid-" + postscript.id
      } else {
        clsName = "highlight confirm pid-" + postscript.id
      }
      new Mark(".main-area").mark(postscript.invalidText, {
        element: "span",
        className: clsName,
        exclude: [
          "script",
          ".app-affiliate-template-name",
          ".inline-advertisement-description",
          ".inline-advertisement-custom-script",
        ],
        diacritics: false,
      })
    })

    // 上記mark.jsによる色つけのループ内で一緒にポップアップの付加をしてしまうと、
    // ポップアップによる文言にもマーカーやポップアップが付加されてしまうため、mark.js
    // による色つけが完全に完了してからポップアップの付加を行っていることに注意
    this.postscripts.forEach((postscript) => {
      // pidでナンバリングしたところにポップアップ用HTMLを差し込む
      const targets = document.querySelectorAll(".pid-" + postscript.id)
      targets.forEach((target) => {
        const popupComponent = Vue.extend(Popup)
        const instance = new popupComponent({ propsData: { postscript } })
        instance.$mount()
        target.appendChild(instance.$el)

        this.setPopupPosition(target)
      })
    })
  }

  // ここでは、マークされた文字列要素(spanを想定)の子要素として仕込んだ
  // ポップアップのノードの出現位置をレンダリングエリアの真ん中の値と比較して
  // 左にあれば、leftを0を設定し、右にあれば、エリアからはみ出ないように-400pxしておく
  private setPopupPosition(target: Element) {
    const center = this.getCenter()
    const rect = target.getBoundingClientRect()
    const popupHTML = target.childNodes[1] as InstanceType<typeof HTMLElement>
    if (center <= rect.left) {
      // right
      popupHTML.style.left = "-400px"
    } else {
      // left
      popupHTML.style.left = "0px"
    }
  }

  // プレビュー用のHTMLがレンダリングされるエリアの中央値を算出する
  private getCenter(): number {
    const mainAreaRect = document.body.getBoundingClientRect()
    return (mainAreaRect.right - mainAreaRect.left) / 2
  }

  private convert() {
    const target = document.querySelectorAll(".main-area")
    const article = this.$store.state.article
    const oldEditorData = article.editorData
    const newEditorData = target[0].innerHTML
    this.isLoading = true
    api
      .applyPostscriptByArticle(article.id, newEditorData)
      .then((res) => {
        this.updateArticle({ editorData: res.data.article.editorData }).then(
          () => {
            this.renderPostscript()
            this.$toasted.success("更新しました")
          }
        )
      })
      .catch((e: AxiosError) => {
        console.log(e)
        this.$toasted.error("自動変換に失敗しました。")
        this.updateArticle({ editorData: oldEditorData }) // エラーの場合は元に戻しておく
      })
      .finally(() => {
        this.isLoading = false
      })
  }
}
